"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.131 6.865C18.524 6.303 17.701 6 16.843 6c-.859 0-1.681.303-2.29.866L12 9.227 9.446 6.866C8.838 6.303 8.016 6 7.158 6c-.86 0-1.682.303-2.289.865-1.157 1.07-1.158 2.735-.004 3.807l7.12 6.602.015-.013.015.013 7.12-6.602c1.154-1.072 1.153-2.737-.004-3.807zm1.363 5.273L12.017 20 12 19.985l-.017.015-8.477-7.862c-2.01-1.863-2.008-4.88.005-6.74C4.517 4.465 5.837 4 7.158 4c1.32 0 2.64.466 3.646 1.397L12 6.503l1.196-1.106C14.203 4.466 15.522 4 16.843 4c1.32 0 2.64.466 3.646 1.397 2.013 1.86 2.015 4.877.005 6.741z" }), "HeartOutline");
//# sourceMappingURL=HeartOutline.js.map